var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-form',{staticClass:"main-navbar__search w-100 d-none d-md-flex d-lg-flex"},[_c('d-input-group',{staticClass:"ml-3",attrs:{"seamless":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }